module.exports = __webpack_public_path__ + "img/8.7d92f8e5.jpeg";